import React, { useEffect, useState } from 'react'
import { getCategoryListApi } from '../../Api/SupplierServices'
import AddTitleMenu from '../../Components/AddTitleMenu/AddTitleMenu'
import MenuTitle from '../../Components/MenuTitlle/MenuTitle'
import SupplierMenuList from '../../Components/SupplierMenuList/SupplierMenuList'
import Style from './AddMenuSupplier.module.css'
const AddMenuSupplier = () => {
    const[categoryList,setCategoryList]=useState([])
    useEffect(()=>{
        getCategoryList()
    },[])

    const getCategoryList =async()=>{
        const data=await getCategoryListApi()
        setCategoryList(data)
    }

 
    
    return (
        <div className={Style.pageHolder}>
            <MenuTitle title={'افزودن منو'}/>
            <div className={Style.imageHolder}><img src="/Assets/Images/Menu/addMenuPage.svg" alt="support" /></div>
            
            <AddTitleMenu UpdateList={getCategoryList}/>
            <SupplierMenuList data={categoryList.category} UpdateList={getCategoryList}/>
            
            
        </div>
    )
}

export default AddMenuSupplier
